import React, { useState, type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  SidePanel,
  SidePanelHeader,
  TABBED_VARIANT_LIGHT,
  Tabbed,
} from 'mailup-web-components'

import BoxAddDynamicFields from 'Pages/RecipientsList/components/insert/BoxAddDynamicFields'
import BoxAddFixedFields from 'Pages/RecipientsList/components/insert/BoxAddFixedFields'
import BoxAddGroups from 'Pages/RecipientsList/components/insert/BoxAddGroups'
import PanelAddRecipientFooter from 'Pages/RecipientsList/components/insert/PanelAddRecipientFooter'
import PanelAddRecipientHeader from 'Pages/RecipientsList/components/insert/PanelAddRecipientHeader'

import { panelAddRecipientState } from 'Pages/RecipientsList/recoil/state/addRecipient'

const PanelAddRecipient: FC = () => {
  const intl = useIntl()

  const [y, setY] = useState(0)

  const { show } = useRecoilValue(panelAddRecipientState)

  const tabs = [
    {
      id: 'dynamicFields',
      label: intl.formatMessage({
        id: 'Load.RecipientsList.DynamicFields',
      }),
      content: <BoxAddDynamicFields />,
    },
    {
      id: 'groups',
      label: intl.formatMessage({ id: 'Load.RecipientsList.Groups' }),
      content: <BoxAddGroups />,
    },
  ]

  return (
    <SidePanel show={show} width="740px" onContentScrollY={setY}>
      <SidePanelHeader padding="16px 32px" showBorder={y > 0}>
        <PanelAddRecipientHeader />
      </SidePanelHeader>

      <Flex flexDirection="column" height="100%">
        <Flex flexDirection="column" gap="24px" padding="24px 32px">
          <BoxAddFixedFields />
          <Tabbed tabs={tabs} variant={TABBED_VARIANT_LIGHT} />
        </Flex>

        <FlexItem flexGrow="1" />

        <PanelAddRecipientFooter />
      </Flex>
    </SidePanel>
  )
}

export default PanelAddRecipient
